import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { getIsMobileScreen } from '@client/redux/modules/clientDevice/selectors';
import { Translate } from '@pegasus/translation';
import { Color } from '@lux/tokens';
import { TitlePreset, Tag } from '@lux/title';
import { Button, ButtonColor, ButtonType } from '@lux/buttons';
import { THB } from '@shared/types/mylounge';

import { Wrapper, THBTitle } from './BannerContent.styles';

interface BannerContentProps {
    thb: THB;
    onButtonClick: (event: React.MouseEvent) => void;
    active?: boolean;
}

export const BannerContent: FunctionComponent<BannerContentProps> = ({
    thb: { text, url, id },
    onButtonClick,
    active,
}) => {
    const allWhitespaces = /^(\s)+$/;
    const validText = !!text && typeof text === 'string' && !allWhitespaces.test(text);
    const validTarget = !!url || !!id;
    const isMobileScreen = useSelector(getIsMobileScreen);

    return (
        validText &&
        validTarget && (
            <Wrapper
                onClick={e => {
                    return !isMobileScreen && e.stopPropagation();
                }}
            >
                <THBTitle color={Color.dark} preset={TitlePreset.XS} tag={Tag.SPAN}>
                    {text}
                </THBTitle>
                <Button
                    color={ButtonColor.primary}
                    onClick={onButtonClick}
                    buttonType={ButtonType.tertiary}
                    tabIndex={active ? 0 : -1}
                >
                    <Translate message="thb.buttonText" />
                </Button>
            </Wrapper>
        )
    );
};

export default BannerContent;
